module.exports = __webpack_public_path__ + "static/media/nuclear.5f5186ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/nuclear.jpg
// module id = 484
// module chunks = 0